/**
 * Toggle a HTML element's CSS class
 */
export function domClassToggle(element: HTMLElement, cssClass: string, isActive: boolean): void {
  isActive === true ? element.classList.add(cssClass) : element.classList.remove(cssClass);
}
